/**
 * Badge colorato per lo stato di una ricezione merce.
 * Usa solo classi Tailwind dal design system.
 */

import React from 'react';

interface StatoRicezioneBadgeProps {
  stato: string;
}

const STATI: Record<string, { label: string; className: string }> = {
  in_verifica: { label: 'In verifica', className: 'bg-warning/10 text-warning' },
  conforme: { label: 'Conforme', className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400' },
  parzialmente_conforme: { label: 'Parz. conforme', className: 'bg-accent/10 text-accent' },
  non_conforme: { label: 'Non conforme', className: 'bg-destructive/10 text-destructive' },
};

export function StatoRicezioneBadge({ stato }: StatoRicezioneBadgeProps) {
  const config = STATI[stato] ?? { label: stato, className: 'bg-muted text-muted-foreground' };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${config.className}`}
    >
      {config.label}
    </span>
  );
}
